import { useState, useEffect, useRef } from "react";

export default function DateField({
  label,
  value,
  onChange,
}) {
  if (typeof onChange !== "function")
    console.debug("A date field doesn't have an onChange callback");

  const containerRef = useRef(null);
  const dayRef = useRef(null);
  const monthRef = useRef(null);
  const yearRef = useRef(null);
  const [inputState, setInputState] = useState('normal');
  const [error, setError] = useState();
  const [day, setDay] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");

  useEffect(() => {
    if (!value) return;

    const matches = value.match(/(\d{4})-(\d{2})-(\d{2})/);
    setYear(matches[1]);
    setMonth(matches[2]);
    setDay(matches[3]);
  }, [value]);

  useEffect(() => {
    if (day.length === 2 && month.length === 2 && year.length === 4)
      onChange(`${year}-${month}-${day}`);
  }, [day, month, year]);

  useEffect(() => {
    if (!dayRef.current) return;

    dayRef.current.style.width = '0';
    dayRef.current.style.width = dayRef.current.scrollWidth + 'px';
  }, [day]);

  useEffect(() => {
    if (!monthRef.current) return;

    monthRef.current.style.width = '0';
    monthRef.current.style.width = monthRef.current.scrollWidth + 'px';
  }, [month]);

  useEffect(() => {
    if (!yearRef.current) return;

    yearRef.current.style.width = '0';
    yearRef.current.style.width = yearRef.current.scrollWidth + 'px';
  }, [year]);

  const handleBlur = (event) => {
    if (containerRef.current && containerRef.current.contains(event.relatedTarget)) return;

    validateDate();
  };

  const validateDate = () => {
    const dateString = `${year}-${month}-${day}`;
    const dateObj = new Date(dateString);
    const isValid =
      dateObj.getFullYear() == year &&
      dateObj.getMonth() + 1 == month &&
      dateObj.getDate() == day;

    if (!isValid) {
      setInputState("error");
      setError("Некорректная дата");
    }
  };

  const changeValue = ({ newValue, setValue, maxLength }) => {
    setInputState("normal");

    let strValue = newValue.toString().replace(/\D/g, "");

    if (strValue.length > maxLength) {
      strValue = strValue.slice(strValue.length - maxLength);
    }

    setValue(strValue);
  };

  const dayDisplayValue = ("__" + day).slice(("__" + day).length - 2);
  const monthDisplayValue = ("__" + month).slice(("__" + month).length - 2);
  const yearDisplayValue = ("____" + year).slice(("____" + year).length - 4);

  return (
    <div className="inpt-grp">
      {label && (
        <label className="lbl">{label}</label>
      )}
      <div ref={containerRef} onBlur={handleBlur}>
        <div className={`inpt-date ${(inputState === "error") && "inpt-error"}`}>
          <input
            type="text"
            value={dayDisplayValue}
            onChange={(event) => changeValue({ newValue: event.target.value, setValue: setDay, maxLength: 2 })}
            onBlur={handleBlur}
            ref={dayRef}
          />
          /
          <input
            type="text"
            value={monthDisplayValue}
            onChange={(event) => changeValue({ newValue: event.target.value, setValue: setMonth, maxLength: 2 })}
            onBlur={handleBlur}
            ref={monthRef}
          />
          /
          <input
            type="text"
            value={yearDisplayValue}
            onChange={(event) => changeValue({ newValue: event.target.value, setValue: setYear, maxLength: 4 })}
            onBlur={handleBlur}
            ref={yearRef}
          />
        </div>

        {(inputState === "error") && <span className="inpt-error-label">{error}</span>}
      </div>
    </div>
  );
}
